import React, { Component } from "react";
import {
  Typography,
  Row,
  Col,
  Table,
  Input,
  Button,
  Icon,
  Form,
  Tooltip,
} from "antd";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import IntlMessages from "../../../services/intlMesseges";
import * as customActions from "../../../redux/actions/custom-alert-actions";
import * as paginationActions from "../../../redux/actions/pagination-actions";
import * as UserService from "../../../services/user-service";
import { bindActionCreators } from "redux";
import moment from "moment";

class CustomAlertList extends Component {
  constructor(props){
    super(props);
    this.module = 'custom_alerts';
    this.state = {
      searchText: "",
      searchedColumn: "",
      data: [],
      pagination: {
        hideOnSinglePage: true,
        showTotal: (total, range) => {
            return (
              <span>
              <IntlMessages id="admin.text.showing" /> {range[0]}-{range[1]}{" "}
              <IntlMessages id="admin.text.of" /> {total}{" "}
              <IntlMessages id="admin.text.results" />
            </span>
          );
        },
        pageSize: 10,
        current: 1
      },
      filters: {}
    };
  }

  getSelectedFilterValue = (index) => {
    return this.props.paginginfo[this.module]&& this.props.paginginfo[this.module].filter && this.props.paginginfo[this.module].filter[index] || null;
  } 
  componentDidMount() {
    this.props.clearPaginationExceptMe(this.module);
    if(this.props.paginginfo && this.props.paginginfo[this.module]){
      this.handleTableChange(UserService.getUser().companyID, this.props.paginginfo[this.module].pagination, this.props.paginginfo[this.module].filter, {},true);
      if(this.props.paginginfo[this.module].filters){
       let filters = this.props.paginginfo[this.module].filters
       Object.keys(filters).map(k=> {filters[k].auto = false});
        this.setState({filters :  filters});
      }
    } else {
      this.handleTableChange(UserService.getUser().companyID, { current: 1, pageSize: 10 }, {}, {}, true);
    }
  }

  handleTableChange = (orgId, pagination, filters, sorter, manual) => {
    if(filters === undefined) filters={};
    Object.keys(filters).map( key => { if((!filters[key]) || (Array.isArray(filters[key]) && filters[key].length===0)) { delete filters[key] }} )
    const pager = { ...this.state.pagination };
    pager.current = pagination.current;
    if(manual !== true)
    {
      this.props.updatePaginationRemoveOld({module:this.module, filter: filters,
      pagination: { current: pagination.current, pageSize: pagination.pageSize }})
    }
    this.setState({ loading: true });
    this.props
      .getAllCustomAlerts(orgId, {
        filters: filters,
        pagination: { page: pagination.current, pageSize: pagination.pageSize },
        sorter: sorter
      })
      .then(resp => {
        pager.total = resp.paging.totalRecords;
        this.setState({
          loading: false,
          data: resp.data,
          pagination: pager
        });
      })
      .catch(ex => {
        this.setState({ loading: false });
      });
  };
  showView(){
    this.props.history.push("view/1")
  }
  getHeaderKeys = () => {
    return [
      {
        title: <IntlMessages id="admin.customalert.name"></IntlMessages>,
        dataIndex: "alertName",
        filteredValue : this.getSelectedFilterValue('alertName'),
        ...this.getColumnSearchProps("alertName")
      },
      {
        title: <IntlMessages id="admin.promo.description"></IntlMessages>,
        dataIndex: "description",
        width:"40%",
        filteredValue : this.getSelectedFilterValue('description'),
        ...this.getColumnSearchProps("description"),
        render:(data,record)=>(
          <span>{record.description !=='' && record.description !=='undefined' ? record.description :''}</span>
        )
      },
      {
        title: <IntlMessages id="admin.customalert.summary"></IntlMessages>,
        dataIndex: "summary",
        filteredValue : this.getSelectedFilterValue('summary'),
        ...this.getColumnSearchProps("summary"),
      },
      {
        title: <IntlMessages id="user.admin.customAlert.usercanreply"></IntlMessages>,
        render: (data, record) => (
          <span>
            {record.userCanReply === true ? 'Yes' : 'No'}

          </span>
        )
      },
      {
        title: <IntlMessages id="admin.manageOrders.createdDate"></IntlMessages>,
        //...this.getColumnSearchProps("description"),
        render: (data, record) => (
          <span>
            {moment(record.insertDate).format('MM/DD/YYYY  hh:mm')}

          </span>
        )
      },
      {
        title: <IntlMessages id="admin.userlisting.action" />,
        rowKey: "action",
        // width: "25%",
        render: (_text, record) => (
          <span>
            <button className="icon"
              onClick={() => this.viewItem(record.autoId)}
            >
              <Tooltip title="View">
                <i className="fas fa-eye"></i>
              </Tooltip>
            </button>
          </span>
        )
      }
    ];
  };

  getColumnSearchProps = dataIndex => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters
    }) => {
      return (
        <div style={{ padding: 8 }}>
          <Input
            ref={node => {
              this.searchInput = node;
            }}
            value={selectedKeys}
            onChange={e =>
              setSelectedKeys(e.target.value ? e.target.value.trimLeft() : "")
            }
            onPressEnter={() =>
              this.handleSearch(
                selectedKeys,
                confirm,
                dataIndex,
                clearFilters,
                setSelectedKeys
              )
            }
            style={{ width: 188, marginBottom: 8, display: "block" }}
          />
          <Button
            type="primary"
            onClick={() =>
              this.handleSearch(
                selectedKeys,
                confirm,
                dataIndex,
                clearFilters,
                setSelectedKeys
              )
            }
            disabled={(selectedKeys != "" && selectedKeys !== null) ? false : true}
            icon="search"
            size="small"
            style={{ width: 90, marginRight: 8 }}
          >
            <IntlMessages id="admin.search" />
          </Button>
          <Button
            disabled={(selectedKeys != "" && selectedKeys !== null) ? false : true}
            onClick={() => this.handleReset(clearFilters, dataIndex)}
            size="small"
            style={{ width: 90 }}
          >
            <IntlMessages id="admin.reset" />
          </Button>
        </div>
      );
    },
    filterIcon: filtered => (
      <Icon type="search" style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    }
  });

  handleSearch = (
    selectedKeys,
    confirm,
    dataIndex,
    clearFilters,
    setSelectedKeys
  ) => {
    if(selectedKeys == ""){
      return false;
    }
    
    this.setState({ searchText: selectedKeys });
    let filters = this.state.filters;
    filters[dataIndex] = {
      val: selectedKeys,
      clearf: clearFilters,
      filter: true,
      setSelectedKeys: setSelectedKeys,
      confirm: confirm,
      auto:true
    };
    this.setState({ filters: filters });
    this.props.updateFilters({module:this.module, filters: filters})
    confirm();
  };

  handleReset = (clearFilters, dataIndex) => {
    clearFilters();
    let filters = this.state.filters;
    if (filters[dataIndex]) {
      if(filters[dataIndex].setSelectedKeys && typeof filters[dataIndex].setSelectedKeys === 'function'){
        filters[dataIndex].setSelectedKeys("");
        //filters[dataIndex].confirm();
      }
    }
    if(filters[dataIndex] && !filters[dataIndex].auto){
      delete this.props.paginginfo[this.module].filter[dataIndex];
      this.handleTableChange({ current: 1, pageSize: 10 }, this.props.paginginfo[this.module].filter, {});
   
    }
    filters[dataIndex] = { val: "", clearf: "", filter: false };
    this.setState({ filters: filters });
    this.props.updateFilters({module: this.module, filters:  filters})
    this.setState({ searchText: "" });
  };
  addItem() {
    this.props.history.push("add/");
  }
  viewItem(id) {
    this.props.history.push("view/" + id);
  }
  tableChange = (pagination, filters, sorter) => {
    this.handleTableChange(UserService.getUser().companyID, pagination, filters, sorter);
  }

  render() {
    let _state = this.state;
    let _this = this;
    let filtertag = Object.keys(this.state.filters).map(function(key1) {
      let keyLabel = _this.getHeaderKeys().find(el => el.dataIndex === key1);
      if (keyLabel.title.props && keyLabel.title.props.id) {
        keyLabel = <IntlMessages id={keyLabel.title.props.id} />;
      } else {
        keyLabel = key1;
      }
      if (_state.filters[key1].filter) {
        return (
          <span>
            <Button
              key={key1}
              type="primary"
              onClick={() =>
                _this.handleReset(_state.filters[key1].clearf, key1)
              }
            >
              {keyLabel} : {_state.filters[key1].val}
              <Icon type="close" />
            </Button>
            &nbsp;
          </span>
        );
      }
    });
    return (
      <div>
        <Row gutter={24}>
          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <Typography.Title level={4}>
              <IntlMessages id="admin.sidebar.submenu.customAlert" />
            </Typography.Title>
          </Col>
          <Col
            xs={24}
            sm={24}
            md={12}
            lg={12}
            xl={12}
            style={{ textAlign: "right" }}
          >
            <Button onClick={() => this.addItem()} type="primary">
              <IntlMessages id="admin.sidebar.submenu.addPricing"></IntlMessages>
            </Button>
          </Col>
        </Row>
        <hr />
        <Row gutter={24} style={{padding: "10px 0"}}>
          <Col>{filtertag}</Col>
        </Row>
        <Row gutter={24}>
          <Col xs={24} sm={24} md={24} lg={24} xl={24} style={{ overflowX: "auto" }}>
            <Table
              bordered
              columns={this.getHeaderKeys()}
              rowKey={record => record.userId}
              dataSource={this.state.data}
              pagination={this.state.pagination}
              loading={this.state.loading}
              onChange={this.tableChange}
            />
          </Col>
        </Row>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return { ...state.user, ...state.pagination };
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators({ ...customActions, ...paginationActions }, dispatch);
}
const WrappedForm = Form.create({ name: "custom-alert" })(CustomAlertList);
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(
    WrappedForm
  )
);

